class TeyutoChatSDK {
    constructor(options) {
        if (typeof URL_API === 'undefined') {
            window.URL_API = "https://api.teyuto.tv/v1";
        }
        
        this.options = {
            container: null,
            videoId: null,
            currentUser: null,
            isAdmin: false,
            allowGuest: true,
            darkMode: true,
            pusher: null,
            player: null,
            onRegisterClick: '', // New option for registration URL
            showTime: true, // New option to control time display
            headers: {}, // New option for custom headers
            disabledEmoji: false,
            disabledSendButton: false,
            ...options
        };
        
        this.messages = [];
        this.stepVideoComments = 1;
        this.scrollCheckLoadComments = false;
        this.liveChatCurrentParentId = null;
        this.currentUserId = null;

        this.loadDependencies()
            .then(() => this.init())
            .catch(error => console.error('Failed to load dependencies:', error));
    }

    loadDependencies() {
        return Promise.all([
            this.loadScript('https://cdn.jsdelivr.net/npm/emoji-mart/dist/browser.js'),
            this.loadStylesheet('https://cdn.jsdelivr.net/npm/emoji-mart/css/emoji-mart.css')
        ]);
    }

    loadScript(src) {
        return new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    loadStylesheet(href) {
        return new Promise((resolve, reject) => {
            if (document.querySelector(`link[href="${href}"]`)) {
                resolve();
                return;
            }
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = resolve;
            link.onerror = reject;
            document.head.appendChild(link);
        });
    }

    init() {
        this.render();
        try {
            this.setupEventListeners();
        } catch (error) {}
        this.getAllMessages(this.options.videoId, this.stepVideoComments, this.options.container);
        this.setupPusher();
        if (!this.options.disabledEmoji) {
            this.setupEmojiPicker();
        }
    }

    render() {
        const showRegisterButton = !this.options.allowGuest && !this.options.currentUser;
        
        this.options.container.innerHTML = `
            <div class="teyuto-chat-live-chat">
                <div class="teyuto-chat-messages-list"></div>
                <div class="teyuto-chat-send-message-space">
                    ${showRegisterButton ? 
                        `<button class="teyuto-chat-button" id="teyuto-chat-register-btn">Register</button>` :
                        `<div id="teyuto-chat-reply-info-box"></div>
                         <div class="teyuto-chat-input-wrapper">
                             <input id="teyuto-chat-input-txt-chat" type="text" class="teyuto-chat-input-txt-chat" placeholder="Write something...">
                             ${!this.options.disabledEmoji ? 
                                `<button id="teyuto-chat-insert-emoji" class="teyuto-chat-insert-emoji">😊</button>` : 
                                ''
                             }
                         </div>
                         ${!this.options.disabledSendButton ? 
                            `<button id="teyuto-chat-send-msg" class="teyuto-chat-send-msg-btn">
                                <svg class="teyuto-chat-send-icon" viewBox="0 0 495.003 495.003" xmlns="http://www.w3.org/2000/svg">
                                    <g id="XMLID_51_">
                                        <path id="XMLID_53_" d="M164.711,456.687c0,2.966,1.647,5.686,4.266,7.072c2.617,1.385,5.799,1.207,8.245-0.468l55.09-37.616 l-67.6-32.22V456.687z"></path>
                                        <path id="XMLID_52_" d="M492.431,32.443c-1.513-1.395-3.466-2.125-5.44-2.125c-1.19,0-2.377,0.264-3.5,0.816L7.905,264.422 c-4.861,2.389-7.937,7.353-7.904,12.783c0.033,5.423,3.161,10.353,8.057,12.689l125.342,59.724l250.62-205.99L164.455,364.414 l156.145,74.4c1.918,0.919,4.012,1.376,6.084,1.376c1.768,0,3.519-0.322,5.186-0.977c3.637-1.438,6.527-4.318,7.97-7.956 L494.436,41.257C495.66,38.188,494.862,34.679,492.431,32.443z"></path>
                                    </g>
                                </svg>
                            </button>` : 
                            ''
                         }`
                    }
                </div>
                ${!this.options.disabledEmoji ? 
                    `<div id="teyuto-chat-emoji-picker" style="display:none; position:absolute;z-index:2;"></div>` : 
                    ''
                }
                <div id="teyuto-chat-username-tooltip" class="teyuto-chat-username-tooltip" style="display:none;">
                    <p>Username</p>
                    <input type="text" class="teyuto-chat-input" id="teyuto-chat-username-input" placeholder="Username">
                    <button id="teyuto-chat-submit-username" class="teyuto-chat-button">Submit</button>
                </div>
            </div>
        `;
        this.applyStyles();

        // Add event listener for register button if it exists and onRegisterClick is provided
        if (showRegisterButton && typeof this.options.onRegisterClick === 'function') {
            const registerButton = this.options.container.querySelector('#teyuto-chat-register-btn');
            registerButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.options.onRegisterClick();
            });
        }
    }

    applyStyles() {
        const styles = `
            .teyuto-chat-live-chat {
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                background-color: transparent;
                display: flex;
						    flex-direction: column;
						    height: 100%;
            }
            .teyuto-chat-live-chat .teyuto-chat-messages-list {
                flex: 5;
                overflow-y: auto;
                overflow-x: hidden;
                height: 95%;
                max-width: 100%;
            }
            .teyuto-chat-live-chat .teyuto-chat-send-message-space {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                width: 100%;
                gap: 5px;
            }
            .teyuto-chat-live-chat .teyuto-chat-input-wrapper {
                flex-grow: 10;
                display: flex;
                width: 100%;
                align-items: center;
                background-color: ${this.options.darkMode ? '#3a3a3a' : '#e1e1e1'};
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                border-radius: 12px;
                padding: 5px 10px;
            }
            .teyuto-chat-live-chat #teyuto-chat-input-txt-chat {
                flex-grow: 1;
                border: none;
                background: transparent;
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                padding: 8px;
                padding-right: 30px;
                width: 100%;
            }
            .teyuto-chat-live-chat #teyuto-chat-insert-emoji {
                background: transparent;
                border: none;
                cursor: pointer;
                font-size: 20px;
                position: absolute;
                right: 30px;
            }
            .teyuto-chat-live-chat #teyuto-chat-send-msg {
                flex-grow: 1;
                width: 100%;
                height: 40px;
                padding: 8px;
                border-radius: 12px;
                border: none;
                background-color: ${this.options.darkMode ? '#3a3a3a' : '#e1e1e1'};
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                cursor: pointer;
                transition: background-color 0.3s ease;
                flex-shrink: 0;
            }
            .teyuto-chat-live-chat #teyuto-chat-send-msg:hover {
                background-color: ${this.options.darkMode ? '#4a4a4a' : '#d1d1d1'};
            }
            .teyuto-chat-live-chat .teyuto-chat-send-icon {
                width: 90%;
                height: 90%;
                fill: ${this.options.darkMode ? '#ffffff' : '#000000'};
            }
            .teyuto-chat-live-chat .teyuto-chat-message {
                position: relative;
                border-bottom: 1px solid ${this.options.darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
                font-size: 13px !important;
                margin-bottom: 10px;
                padding: 10px;
            }
            .teyuto-chat-live-chat .teyuto-chat-parent-box{
                border-left: 1px solid ${this.options.darkMode ? 'rgba(225, 225, 225, 0.2)' : 'rgba(0, 0, 0, 0.2)'};
                margin-left: 30px;
            }
            .teyuto-chat-live-chat .teyuto-chat-message:hover {
                background-color: ${this.options.darkMode ? 'rgba(225, 225, 225, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
                border-radius: 6px;
            }
            .teyuto-chat-live-chat .teyuto-chat-message-toolbar {
                display: none;
                position: absolute;
                right: 0px;
                top: 0px;
                background-color: ${this.options.darkMode ? '#1a1a1a' : '#f1f1f1'};
                border-radius: 6px;
                padding: 5px;
            }
            .teyuto-chat-live-chat .teyuto-chat-message:hover > .teyuto-chat-message-toolbar {
                display: block;
            }
            .teyuto-chat-live-chat .teyuto-chat-message img {
                border-radius: 50%;
                float: left;
                margin-right: 10px;
            }
            .teyuto-chat-live-chat .teyuto-chat-title-h5-user {
                font-size: 14px;
                text-transform: capitalize;
                margin: 0;
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
            }
            .teyuto-chat-message-username{
                opacity: 0.7;
            }
            .teyuto-chat-live-chat .teyuto-chat-live-message {
                max-width: 100%;
                word-wrap: break-word;
                margin: 0px;
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
            }
             .teyuto-chat-username-tooltip {
                position: relative;
                margin-top: -50px;
                background-color: ${this.options.darkMode ? '#2a2a2a' : '#f1f1f1'};
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                border: 1px solid ${this.options.darkMode ? '#3a3a3a' : '#d1d1d1'};
                border-radius: 4px;
                padding: 10px;
                z-index: 1000;
            }
            .teyuto-chat-live-chat .teyuto-chat-username-tooltip input,
            .teyuto-chat-live-chat .teyuto-chat-username-tooltip button {
                margin-top: 5px;
                padding: 5px;
                width: 100%;
            }
            .teyuto-chat-live-chat .teyuto-chat-tooltip {
                position: relative;
                display: inline-block;
                cursor: pointer;
            }
            @media (max-width: 390px) {
                .teyuto-chat-live-chat #teyuto-chat-input-txt-chat {
                    padding-right: 8px;
                }
                .teyuto-chat-insert-emoji{
                    display:none;
                }
                .teyuto-chat-live-chat .teyuto-chat-send-message-space {
                    flex-direction: column;
                }
                .teyuto-chat-live-chat #teyuto-chat-send-msg {
                    width: 100% !important;
                    height: 40px;
                }
                .teyuto-chat-live-chat .teyuto-chat-input-wrapper {
                    width: 100% !important;
                }
                .teyuto-chat-live-chat .teyuto-chat-send-icon {
                    width: 24px;
                    height: 24px;
                    margin: 0 auto;
                }
            }

            @keyframes teyuto-chat-spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            .teyuto-chat-loader {
                width: 30px;
                height: 30px;
                border: 3px solid #3a3a3a;
                border-top: 3px solid ${this.options.darkMode ? '#fff' : '#000'};
                border-radius: 50%;
                animation: teyuto-chat-spin 1s linear infinite;
            }
            .teyuto-chat-live-chat .teyuto-chat-button {
                width: 100%;
                padding: 10px;
                background-color: ${this.options.darkMode ? '#3a3a3a' : '#e1e1e1'};
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                text-align: center;
                text-decoration: none;
                border-radius: 12px;
                font-weight: bold;
                transition: background-color 0.3s ease;
                border: none;
                cursor: pointer;
            }
            .teyuto-chat-live-chat .teyuto-chat-button:hover {
                background-color: ${this.options.darkMode ? '#4a4a4a' : '#d1d1d1'};
            }
            .teyuto-chat-live-chat .teyuto-chat-no-messages-icon-fill {
                fill: ${this.options.darkMode ? '#ffffff' : '#1C274C'};
            }
            .teyuto-chat-live-chat .teyuto-chat-no-messages-icon-stroke {
                stroke: ${this.options.darkMode ? '#ffffff' : '#1C274C'};
            }
            .teyuto-chat-live-chat .teyuto-chat-no-messages {
                color: ${this.options.darkMode ? '#ffffff' : '#1C274C'};
            }
            .teyuto-chat-live-chat .teyuto-chat-message-date {
                display: ${this.options.showTime ? 'inline' : 'none'};
                font-size: 12px;
                color: ${this.options.darkMode ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'};
            }
            .teyuto-chat-live-chat .teyuto-chat-input {
                width: 100%;
                padding: 8px;
                border: none;
                border-radius: 12px;
                background-color: ${this.options.darkMode ? '#2a2a2a' : '#f1f1f1'};
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                font-size: 14px;
                transition: background-color 0.3s ease;
            }
            .teyuto-chat-live-chat .teyuto-chat-input:focus {
                outline: none;
                background-color: ${this.options.darkMode ? '#3a3a3a' : '#e1e1e1'};
            }
            .teyuto-chat-live-chat .teyuto-chat-input::placeholder {
                color: ${this.options.darkMode ? '#999999' : '#666666'};
            }
             .teyuto-chat-live-chat .teyuto-chat-icon {
                cursor: pointer;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background-color: ${this.options.darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
                transition: background-color 0.3s ease;
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                position: relative;  // Aggiunto per posizionamento del tooltip
            }

            .teyuto-chat-live-chat .teyuto-chat-icon:hover {
                background-color: ${this.options.darkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'};
            }

            .teyuto-chat-live-chat .teyuto-chat-icon svg {
                width: 16px;
                height: 16px;
                fill: currentColor;
            }

            .teyuto-chat-live-chat .teyuto-chat-tooltip {
                position: relative;
            }

            .teyuto-chat-live-chat .teyuto-chat-tooltip .teyuto-chat-tooltiptext {
                visibility: hidden;
                width: auto;
                background-color: ${this.options.darkMode ? '#4a4a4a' : '#f1f1f1'};
                color: ${this.options.darkMode ? '#ffffff' : '#000000'};
                text-align: center;
                border-radius: 6px;
                padding: 5px 10px;
                position: absolute;
                z-index: 1;
                top: 30px;
                left: 50%;
                transform: translateX(-50%);
                opacity: 0;
                transition: opacity 0.3s;
                white-space: nowrap;
                font-size: 12px;
                pointer-events: none;
            }

            .teyuto-chat-live-chat .teyuto-chat-tooltip:hover .teyuto-chat-tooltiptext {
                visibility: visible;
                opacity: 1;
            }

            .teyuto-chat-user-name{
                opacity: 0.7;
            }
        `;
        const styleElement = document.createElement('style');
        styleElement.textContent = styles;
        document.head.appendChild(styleElement);
    }

    setupEventListeners() {
        if (!this.options.disabledSendButton) {
            const sendButton = this.options.container.querySelector('#teyuto-chat-send-msg');
            if (sendButton) {
                sendButton.addEventListener('click', () => this.sendMessageNow(this.options.videoId, this.options.container, this.options.allowGuest));
            }
        }

        // Add global keyboard event listener
        document.addEventListener('keypress', (e) => {
            if ((e.key === 'Enter' || e.keyCode === 13)) {
                e.preventDefault();
                this.sendMessageNow(this.options.videoId, this.options.container, this.options.allowGuest);
            }
        });

        if (!this.options.disabledEmoji) {
            const emojiButton = this.options.container.querySelector('#teyuto-chat-insert-emoji');
            if (emojiButton) {
                emojiButton.addEventListener('click', (event) => {
                    event.stopPropagation();
                    const emojiPicker = this.options.container.querySelector('#teyuto-chat-emoji-picker');
                    emojiPicker.style.display = emojiPicker.style.display === 'none' ? 'block' : 'none';
                });
            }
        }

        const messagesList = this.options.container.querySelector('.teyuto-chat-messages-list');
        messagesList.addEventListener('scroll', (e) => {
            const scrollTop = e.target.scrollTop;
            if (scrollTop < 50 && !this.scrollCheckLoadComments) {
                this.scrollCheckLoadComments = true;
                this.stepVideoComments++;
                this.getAllMessages(this.options.videoId, this.stepVideoComments, this.options.container);
            }

            const isScrolledToBottom = messagesList.scrollHeight - messagesList.clientHeight <= messagesList.scrollTop + 100;
            if (isScrolledToBottom) {
                const scrollButton = this.options.container.querySelector('#teyuto-chat-scroll-bottom');
                if (scrollButton) {
                    scrollButton.style.display = 'none';
                }
            }
        });

        this.options.container.addEventListener('click', (e) => {
            if (e.target.closest('.teyuto-chat-message-reply')) {
                const replyButton = e.target.closest('.teyuto-chat-message-reply');
                const chatId = replyButton.dataset.chatId;
                const parentId = replyButton.dataset.parentId;
                const user = replyButton.dataset.user;
                //use chatId for multi-thread
                this.setReplyInChat(parentId, user);
            } else if (e.target.closest('.teyuto-chat-user-ban')) {
                const banButton = e.target.closest('.teyuto-chat-user-ban');
                const userId = banButton.dataset.userId;
                this.userBanLiveChat(userId);
            } else if (e.target.closest('.teyuto-chat-comment-delete')) {
                const deleteButton = e.target.closest('.teyuto-chat-comment-delete');
                const chatId = deleteButton.dataset.chatId;
                this.deleteMessage(chatId);
            }
        });

    }

    setupPusher() {
        if (!this.options.pusher) {
            console.error('Pusher instance is not provided');
            return;
        }

        const channel = this.options.pusher.subscribe(`teyuto_live_chat_${this.options.videoId}`);
        channel.bind('live_chat', (data) => {
            var text = JSON.parse(data);
            if(text[0]){
                text=text[0];
            }
            
            if (this.currentUserId !== -1 && this.currentUserId !== text.userId) {
                var messageLive = this.textReplaceURLs(text.message);

                let el = {
                    idChat: text.idChat,
                    parent_id: text.parent_id,
                    childs: text.childs,
                    profile_image: text.avatar,
                    user: text.user,
                    userId: text.userId,
                    message: messageLive,
                    date: text.date
                };

                let chatHTML = this.createElementChat(el);

                const noMessagesElement = this.options.container.querySelector('.teyuto-chat-no-messages');
                if (noMessagesElement) {
                    noMessagesElement.remove();
                }

                if (el.parent_id) {
                    // This is a reply, insert it into the correct parent box
                    const parentBox = this.options.container.querySelector(`#teyuto-chat-parent-${el.parent_id}`);
                    if (parentBox) {
                        this.options.container.querySelector(`#teyuto-chat-parent-${el.parent_id}`).insertAdjacentHTML('beforeend', chatHTML);
                    } else {
                        console.warn(`Parent box #teyuto-chat-parent-${el.parent_id} not found. Inserting as a new message.`);
                        this.options.container.querySelector('.teyuto-chat-messages-list').insertAdjacentHTML('beforeend', chatHTML);
                    }
                } else {
                    // This is a new main message
                    this.options.container.querySelector('.teyuto-chat-messages-list').insertAdjacentHTML('beforeend', chatHTML);
                }

                this.checkScrollAndUpdate();
            }
        });
        channel.bind('delete_chat', (data) => {
            var obj = JSON.parse(data); 
            if(obj.id){
                this.options.container.querySelector(`.teyuto-chat-item-message${obj.id}`)?.remove();
            }
        });

        const generalChannel = this.options.pusher.subscribe('teyuto_general');
        generalChannel.bind('ban', (data) => {
            var obj = JSON.parse(data);
            if(obj.id){
                this.options.container.querySelector(`.teyuto-chat-user-id-message${obj.id}`)?.remove();
            }
        });
    }

    checkScrollAndUpdate() {
        const messagesList = this.options.container.querySelector('.teyuto-chat-messages-list');
        const isScrolledToBottom = messagesList.scrollHeight - messagesList.clientHeight <= messagesList.scrollTop + 100;
        if (isScrolledToBottom) {
            this.scrollToBottom();
        } else if (!isScrolledToBottom) {
            this.showScrollToBottomButton();
        }
    }

    showScrollToBottomButton() {
        let scrollButton = this.options.container.querySelector('#teyuto-chat-scroll-bottom');
        if (!scrollButton) {
            scrollButton = document.createElement('button');
            scrollButton.id = 'teyuto-chat-scroll-bottom';
            scrollButton.innerHTML = '⬇';
            scrollButton.style.position = 'absolute';
            scrollButton.style.bottom = '100px';
            scrollButton.style.right = '30px';
            scrollButton.style.zIndex = '1000';
            scrollButton.style.padding = '5px 10px';
            scrollButton.style.borderRadius = '50%';
            scrollButton.style.backgroundColor = this.options.darkMode ? '#4a4a4a' : '#e1e1e1';
            scrollButton.style.color = this.options.darkMode ? '#ffffff' : '#000000';
            scrollButton.style.border = 'none';
            scrollButton.style.cursor = 'pointer';
            scrollButton.onclick = () => this.scrollToBottom();
            this.options.container.appendChild(scrollButton);
        }
        scrollButton.style.display = 'block';
    }

    setupEmojiPicker() {
        const picker = new EmojiMart.Picker({
            onEmojiSelect: (emoji) => {
                const inputField = this.options.container.querySelector('#teyuto-chat-input-txt-chat');
                inputField.value += emoji.native;
                this.options.container.querySelector('#teyuto-chat-emoji-picker').style.display = 'none';
            }
        });
        
        const emojiPickerContainer = this.options.container.querySelector('#teyuto-chat-emoji-picker');
        emojiPickerContainer.innerHTML = '';
        emojiPickerContainer.appendChild(picker);
    }

    getAllMessages(idl, step, elAppend) {
        const loaderHTML = `
        <div class="teyuto-chat-loading-circle" id="teyuto-chat-loading-circle">
            <div class="teyuto-chat-loader"></div>
        </div>
        `;
        elAppend.insertAdjacentHTML('afterbegin', loaderHTML);

        fetch(`${URL_API}/video_chat/?f=list_chat&idl=${idl}&step=${step}`, {
            headers: this.options.headers // Use custom headers
        })
            .then(response => response.json())
            .then(objJson => {
                let chatHTML = '';
                elAppend.querySelector('#teyuto-chat-loading-circle').remove();

                if (objJson.length > 0) {
                    for (var i in objJson) {
                        if (i == (objJson.length-1) && step == 1) {
                            if(this.options.firstMessageContainer){
                                this.options.firstMessageContainer.innerHTML = `
                                <span class="teyuto-chat-user-name">${objJson[i].user}</span>
                                <span class="teyuto-chat-first-message">${objJson[i].message}</span>
                            `;
                            }
                        }
                        let el = {
                            idChat: objJson[i].idChat,
                            parent_id: objJson[i].parent_id,
                            childs: objJson[i].childs,
                            profile_image: objJson[i].profile_image,
                            user: objJson[i].user,
                            userId: objJson[i].userId,
                            message: objJson[i].message,
                            date: objJson[i].date
                        }
                        chatHTML += this.createElementChat(el);
                    }

                    elAppend.querySelector('.teyuto-chat-messages-list').insertAdjacentHTML('afterbegin', chatHTML);

                    if (objJson.length < 15) {
                        this.scrollCheckLoadComments = true;
                    } else {
                        this.scrollCheckLoadComments = false;
                    }

                } else if (step == 1) {
                    this.scrollCheckLoadComments = true;
                    elAppend.querySelector('.teyuto-chat-messages-list').insertAdjacentHTML('afterbegin', `
                        <div class="teyuto-chat-no-messages" style="display: flex; justify-content: center; align-items: center; height: 100%; flex-direction: column; opacity:0.7;">
                            <svg width="76" height="76" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="teyuto-chat-no-messages-icon">
                                <path d="M13.0867 21.3877L13.7321 21.7697L13.0867 21.3877ZM13.6288 20.4718L12.9833 20.0898L13.6288 20.4718ZM10.3712 20.4718L9.72579 20.8539H9.72579L10.3712 20.4718ZM10.9133 21.3877L11.5587 21.0057L10.9133 21.3877ZM2.3806 15.9134L3.07351 15.6264V15.6264L2.3806 15.9134ZM7.78958 18.9915L7.77666 19.7413L7.78958 18.9915ZM5.08658 18.6194L4.79957 19.3123H4.79957L5.08658 18.6194ZM21.6194 15.9134L22.3123 16.2004V16.2004L21.6194 15.9134ZM16.2104 18.9915L16.1975 18.2416L16.2104 18.9915ZM18.9134 18.6194L19.2004 19.3123H19.2004L18.9134 18.6194ZM19.6125 2.7368L19.2206 3.37628L19.6125 2.7368ZM21.2632 4.38751L21.9027 3.99563V3.99563L21.2632 4.38751ZM4.38751 2.7368L3.99563 2.09732V2.09732L4.38751 2.7368ZM2.7368 4.38751L2.09732 3.99563H2.09732L2.7368 4.38751ZM9.40279 19.2098L9.77986 18.5615L9.77986 18.5615L9.40279 19.2098ZM13.7321 21.7697L14.2742 20.8539L12.9833 20.0898L12.4412 21.0057L13.7321 21.7697ZM9.72579 20.8539L10.2679 21.7697L11.5587 21.0057L11.0166 20.0898L9.72579 20.8539ZM12.4412 21.0057C12.2485 21.3313 11.7515 21.3313 11.5587 21.0057L10.2679 21.7697C11.0415 23.0767 12.9585 23.0767 13.7321 21.7697L12.4412 21.0057ZM10.5 2.75H13.5V1.25H10.5V2.75ZM21.25 10.5V11.5H22.75V10.5H21.25ZM2.75 11.5V10.5H1.25V11.5H2.75ZM1.25 11.5C1.25 12.6546 1.24959 13.5581 1.29931 14.2868C1.3495 15.0223 1.45323 15.6344 1.68769 16.2004L3.07351 15.6264C2.92737 15.2736 2.84081 14.8438 2.79584 14.1847C2.75041 13.5189 2.75 12.6751 2.75 11.5H1.25ZM7.8025 18.2416C6.54706 18.2199 5.88923 18.1401 5.37359 17.9265L4.79957 19.3123C5.60454 19.6457 6.52138 19.7197 7.77666 19.7413L7.8025 18.2416ZM1.68769 16.2004C2.27128 17.6093 3.39066 18.7287 4.79957 19.3123L5.3736 17.9265C4.33223 17.4951 3.50486 16.6678 3.07351 15.6264L1.68769 16.2004ZM21.25 11.5C21.25 12.6751 21.2496 13.5189 21.2042 14.1847C21.1592 14.8438 21.0726 15.2736 20.9265 15.6264L22.3123 16.2004C22.5468 15.6344 22.6505 15.0223 22.7007 14.2868C22.7504 13.5581 22.75 12.6546 22.75 11.5H21.25ZM16.2233 19.7413C17.4786 19.7197 18.3955 19.6457 19.2004 19.3123L18.6264 17.9265C18.1108 18.1401 17.4529 18.2199 16.1975 18.2416L16.2233 19.7413ZM20.9265 15.6264C20.4951 16.6678 19.6678 17.4951 18.6264 17.9265L19.2004 19.3123C20.6093 18.7287 21.7287 17.6093 22.3123 16.2004L20.9265 15.6264ZM13.5 2.75C15.1512 2.75 16.337 2.75079 17.2619 2.83873C18.1757 2.92561 18.7571 3.09223 19.2206 3.37628L20.0044 2.09732C19.2655 1.64457 18.4274 1.44279 17.4039 1.34547C16.3915 1.24921 15.1222 1.25 13.5 1.25V2.75ZM22.75 10.5C22.75 8.87781 22.7508 7.6085 22.6545 6.59611C22.5572 5.57256 22.3554 4.73445 21.9027 3.99563L20.6237 4.77938C20.9078 5.24291 21.0744 5.82434 21.1613 6.73809C21.2492 7.663 21.25 8.84876 21.25 10.5H22.75ZM19.2206 3.37628C19.7925 3.72672 20.2733 4.20752 20.6237 4.77938L21.9027 3.99563C21.4286 3.22194 20.7781 2.57144 20.0044 2.09732L19.2206 3.37628ZM10.5 1.25C8.87781 1.25 7.6085 1.24921 6.59611 1.34547C5.57256 1.44279 4.73445 1.64457 3.99563 2.09732L4.77938 3.37628C5.24291 3.09223 5.82434 2.92561 6.73809 2.83873C7.663 2.75079 8.84876 2.75 10.5 2.75V1.25ZM2.75 10.5C2.75 8.84876 2.75079 7.663 2.83873 6.73809C2.92561 5.82434 3.09223 5.24291 3.37628 4.77938L2.09732 3.99563C1.64457 4.73445 1.44279 5.57256 1.34547 6.59611C1.24921 7.6085 1.25 8.87781 1.25 10.5H2.75ZM3.99563 2.09732C3.22194 2.57144 2.57144 3.22194 2.09732 3.99563L3.37628 4.77938C3.72672 4.20752 4.20752 3.72672 4.77938 3.37628L3.99563 2.09732ZM11.0166 20.0898C10.8136 19.7468 10.6354 19.4441 10.4621 19.2063C10.2795 18.9559 10.0702 18.7304 9.77986 18.5615L9.02572 19.8582C9.07313 19.8857 9.13772 19.936 9.24985 20.0898C9.37122 20.2564 9.50835 20.4865 9.72579 20.8539L11.0166 20.0898ZM7.77666 19.7413C8.21575 19.7489 8.49387 19.7545 8.70588 19.7779C8.90399 19.7999 8.98078 19.832 9.02572 19.8582L9.77986 18.5615C9.4871 18.3912 9.18246 18.3215 8.87097 18.287C8.57339 18.2541 8.21375 18.2487 7.8025 18.2416L7.77666 19.7413ZM14.2742 20.8539C14.4916 20.4865 14.6287 20.2564 14.7501 20.0898C14.8622 19.936 14.9268 19.8857 14.9742 19.8582L14.2201 18.5615C13.9298 18.7304 13.7204 18.9559 13.5379 19.2063C13.3646 19.4441 13.1864 19.7468 12.9833 20.0898L14.2742 20.8539ZM16.1975 18.2416C15.7862 18.2487 15.4266 18.2541 15.129 18.287C14.8175 18.3215 14.5129 18.3912 14.2201 18.5615L14.9742 19.8582C15.0192 19.832 15.096 19.7999 15.2941 19.7779C15.5061 19.7545 15.7842 19.7489 16.2233 19.7413L16.1975 18.2416Z" class="teyuto-chat-no-messages-icon-fill"/>
                                <path d="M8 9H16" class="teyuto-chat-no-messages-icon-stroke" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M8 12.5H13.5" class="teyuto-chat-no-messages-icon-stroke" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                            <p style="margin-top: 10px; text-align: center;">No messages yet</p>
                        </div>
                    `);
                }

                if (step == 1) {
                    this.scrollToBottom();
                }
            })
            .catch(error => console.error('Error:', JSON.stringify(error)));
    }

    createElementChat(el) {
        let chatHTML = '';
      
        const createChatMessage = (el) => {
          let messageHTML = `
                <div class="teyuto-chat-user-id-message${el.userId} teyuto-chat-item-message${el.idChat} teyuto-chat-message">
                    <img class="teyuto-chat-avatar" src="${el.profile_image}" alt="" width="26" height="26">
                    <div class="teyuto-chat-message-content">
                        <h5 class="teyuto-chat-title-h5-user">
                            <span class="teyuto-chat-message-username">${el.user}</span>
                            ${this.options.showTime ? `<br><span class="teyuto-chat-message-date">${el.date}</span>` : ''}
                        </h5>
                        <p class="teyuto-chat-live-message">
                            <span>${this.chatColorStringMention(el.message)}</span>
                        </p>
                    </div>
                    <div class="teyuto-chat-message-toolbar">
                      <span class="teyuto-chat-message-reply teyuto-chat-tooltip teyuto-chat-icon" data-chat-id="${el.idChat}" data-parent-id="${el.parent_id}" data-user="${el.user}">
                        <svg viewBox="0 0 24 24" width="16" height="16">
                          <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" fill="currentColor"/>
                        </svg>
                        <span class="teyuto-chat-tooltiptext">Reply</span>
                      </span>
                      ${(this.options.isAdmin) ? this.createUserBanButton(el.userId, el.idChat) : ''}
                    </div>
                </div>`;
      
            messageHTML += `<div class="teyuto-chat-parent-box" id="teyuto-chat-parent-${el.idChat}">`;
            if (el.childs && el.childs.length > 0) {
              el.childs.forEach(childEl => {
                messageHTML += createChatMessage(childEl);
              });
            }
            messageHTML += `</div>`;
      
          return messageHTML;
        }
      
        chatHTML += createChatMessage(el);
      
        return chatHTML;
    }

    scrollToBottom() {
        const messagesListElement = this.options.container.querySelector('.teyuto-chat-messages-list');
        messagesListElement.scrollTop = messagesListElement.scrollHeight;
    }

    sendMessageNow(video_id, elAppend, allowGuest=false) {
        const inputElement = this.options.container.querySelector("#teyuto-chat-input-txt-chat");
        const message = inputElement.value;

        if (this.options.currentUser === null && (!sessionStorage.getItem('guestUsername') && allowGuest)) {
            this.showUsernameTooltip(inputElement, (username) => {
                this.sendMessageWithUsername(username, video_id, elAppend);
            });
            return;
        }

        this.sendMessageWithUsername(this.options.currentUser !== null ? this.options.currentUser.display_name : sessionStorage.getItem('guestUsername'), video_id, elAppend);
    }

    sendMessageWithUsername(username, video_id, elAppend) {
        const avatar = this.options.currentUser !== null ? this.options.currentUser.profile_image : 'https://api.dicebear.com/9.x/initials/svg?seed='+username;
        this.sendMessageLiveChat(this.options.container.querySelector("#teyuto-chat-input-txt-chat").value, video_id, this.getCurrentTimePlayer(), avatar, username, elAppend);
        this.options.container.querySelector("#teyuto-chat-input-txt-chat").value = ''; // Clear the input after sending
    }
    
    sendMessageLiveChat(message, idl, ct, avatar, user, elAppend) {
        if (message != "") {

            this.currentUserId = -1;

            var dateWithouthSecond = new Date();
            var hm = dateWithouthSecond.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' })
            this.options.container.querySelector("#teyuto-chat-input-txt-chat").value = "";
            var messageLiveSend = this.textReplaceURLs(message);

            const noMessagesElement = this.options.container.querySelector('.teyuto-chat-no-messages');
            if (noMessagesElement) {
                noMessagesElement.remove();
            }

            // Create a temporary ID for the message and user
            const tempMessageId = 'temp-msg-' + Date.now();
            const tempUserId = 'temp-user-' + Date.now();

            let el = {
                idChat: tempMessageId,
                userId: tempUserId,
                profile_image: avatar,
                user: user,
                message: messageLiveSend,
                date: hm,
                parent_id: this.liveChatCurrentParentId
            }
            let chatHTML = this.createElementChat(el);

            if(this.liveChatCurrentParentId){
                this.options.container.querySelector(`#teyuto-chat-parent-${this.liveChatCurrentParentId}`).insertAdjacentHTML('beforeend', chatHTML);
            } else {
                this.options.container.querySelector('.teyuto-chat-messages-list').insertAdjacentHTML('beforeend', chatHTML);
                this.scrollToBottom();
            }

            var formData = new FormData();
            formData.append('message', message);
            formData.append('idl', idl);
            formData.append('time_live', ct);
            formData.append('avatar', avatar);
            formData.append('user', user);
            if(this.liveChatCurrentParentId){
                formData.append('parent_id', this.liveChatCurrentParentId);
            }

            this.stopReplyInChat();

            if (typeof teyutoShopifyHostToken !== 'undefined' && teyutoShopifyHostToken !== null && teyutoShopifyHostToken !== '') {
                formData.append('live_shopping_host_token', teyutoShopifyHostToken);
            }

            fetch(`${URL_API}/video_chat/?f=send_message`, {
                method: 'POST',
                headers: this.options.headers,
                body: formData,
            })
            .then(response => response.json())
            .then(data => {
                data = data[0];
                this.currentUserId = data.userId;
                // Update the message with the correct IDs
                if (data.idChat && data.userId) {
                    const messageElement = this.options.container.querySelector(`.teyuto-chat-item-message${tempMessageId}`);
                    if (messageElement) {
                        // Update classes
                        messageElement.classList.remove(`teyuto-chat-item-message${tempMessageId}`);
                        messageElement.classList.add(`teyuto-chat-item-message${data.idChat}`);
                        messageElement.classList.remove(`teyuto-chat-user-id-message${tempUserId}`);
                        messageElement.classList.add(`teyuto-chat-user-id-message${data.userId}`);
                        
                        // Update data attributes
                        const replyButton = messageElement.querySelector('.teyuto-chat-message-reply');
                        if (replyButton) {
                            replyButton.dataset.chatId = data.idChat;
                            replyButton.dataset.parentId = 0;
                        }
                        const deleteButton = messageElement.querySelector('.teyuto-chat-comment-delete');
                        if (deleteButton) {
                            deleteButton.dataset.chatId = data.idChat;
                        }
                        const banButton = messageElement.querySelector('.teyuto-chat-user-ban');
                        if (banButton) {
                            banButton.dataset.userId = data.userId;
                        }

                        // Update parent box id if it exists
                        const parentBox = this.options.container.querySelector(`#teyuto-chat-parent-${tempMessageId}`);
                        if (parentBox) {
                            parentBox.id = `teyuto-chat-parent-${data.idChat}`;
                        }

                        // Update the date if it's provided in the response
                        if (data.date) {
                            const dateElement = messageElement.querySelector('.teyuto-chat-message-date');
                            if (dateElement) {
                                dateElement.textContent = data.date;
                            }
                        }

                        console.log('Message updated successfully:', data);
                    } else {
                        console.error('Message element not found:', tempMessageId);
                    }
                } else {
                    console.error('Invalid response data:', data);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }

    getCurrentTimePlayer() {
        try {
            if (this.options.player && typeof this.options.player.currentTime === 'function') {
                return this.options.player.currentTime() || 0;
            }
            return 0;
        } catch (error) {
            console.error('Error getting player time:', error);
            return -1;
        }
    }

    showUsernameTooltip(inputElement, callback) {
        const tooltipId = 'teyuto-chat-username-tooltip';
        const tooltip = this.options.container.querySelector(`#${tooltipId}`);
        
        if (tooltip) {
 
            tooltip.style.display = 'block';

            const usernameInput = tooltip.querySelector('#teyuto-chat-username-input');
            const submitButton = tooltip.querySelector('#teyuto-chat-submit-username');

            const submitHandler = () => {
                const username = usernameInput.value.trim();
                if (username) {
                    sessionStorage.setItem('guestUsername', username);
                    tooltip.style.display = 'none';
                    callback(username);
                }
            };

            submitButton.onclick = submitHandler;
            usernameInput.onkeypress = (e) => {
                if (e.key === 'Enter') {
                    submitHandler();
                }
            };

            usernameInput.focus();
        } else {
            console.error('Username tooltip element not found');
        }
    }

    stopReplyInChat(){
        this.options.container.querySelector('#teyuto-chat-reply-info-box-content')?.remove();
        this.liveChatCurrentParentId = null;
    }

    setReplyInChat(id, user) {
        this.liveChatCurrentParentId = id;
        const replyInfoBox = this.options.container.querySelector('#teyuto-chat-reply-info-box');
        replyInfoBox.innerHTML = `
            <div id="teyuto-chat-reply-info-box-content">
                Reply to <b>@${user}</b> 
                <span class="teyuto-chat-close-reply">X</span>
            </div>
        `;
        this.options.container.querySelector('#teyuto-chat-input-txt-chat').value = `@${user} `;
        this.options.container.querySelector('#teyuto-chat-input-txt-chat').focus();

        const closeReplyButton = replyInfoBox.querySelector('.teyuto-chat-close-reply');
        closeReplyButton.addEventListener('click', () => this.stopReplyInChat());
    }

    createUserBanButton(userId, chatId) {
        return `
            <span class='teyuto-chat-user-ban teyuto-chat-tooltip teyuto-chat-icon' data-user-id="${userId}"> 
                <svg viewBox="0 0 24 24" width="16" height="16">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" fill="currentColor"/>
                </svg>
                <span class="teyuto-chat-tooltiptext">Ban</span>
            </span>
            <span class='teyuto-chat-comment-delete teyuto-chat-tooltip teyuto-chat-icon' data-chat-id="${chatId}"> 
                <svg viewBox="0 0 24 24" width="16" height="16">
                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor"/>
                </svg>
                <span class="teyuto-chat-tooltiptext">Delete</span>
            </span>`;
    }

    userBanLiveChat(id) {
        var formData = new FormData();
        formData.append('id', id);

        if (typeof teyutoShopifyHostToken !== 'undefined' && teyutoShopifyHostToken !== null) {
            formData.append('live_shopping_host_token', teyutoShopifyHostToken);
        }

        if (typeof teyutoCurrentVideoId !== 'undefined' && teyutoCurrentVideoId !== null) {
            formData.append('video_id', teyutoCurrentVideoId);
        }

        fetch(`${URL_API}/user/?f=ban`, {
            method: 'POST',
            headers: this.options.headers, // Include custom headers
            body: formData
        })
        .then(response => response.json())
        .then(objJson => {
            if (objJson.status == "ban_add") {
                this.openNotificationsToast("User banned");
                const banButton = this.options.container.querySelector(`.teyuto-chat-user-ban[data-user-id="${id}"]`);
                if (banButton) {
                    banButton.querySelector('.teyuto-chat-tooltiptext').textContent = 'Unlock User';
                }
            } else {
                this.openNotificationsToast("Ban removed");
                const banButton = this.options.container.querySelector(`.teyuto-chat-user-ban[data-user-id="${id}"]`);
                if (banButton) {
                    banButton.querySelector('.teyuto-chat-tooltiptext').textContent = 'Ban User';
                }
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            this.openNotificationsToast("Error occurred while banning/unbanning user");
        });
    }

    deleteMessage(id) {
        if (!confirm("Are you sure you want to delete this message?")) {
            return false;
        }
        var formData = new FormData();
        formData.append('id', id);

        if (typeof teyutoShopifyHostToken !== 'undefined' && teyutoShopifyHostToken !== null) {
            formData.append('live_shopping_host_token', teyutoShopifyHostToken);
        }

        const messageElement = this.options.container.querySelector(`.teyuto-chat-item-message${id}`);
        if (messageElement) {
            messageElement.remove();
            this.openNotificationsToast("Message deleted");
        } else {
            console.error('Message element not found');
            this.openNotificationsToast("Error: Message not found");
        }

        fetch(`${URL_API}/video_chat/?f=delete_message`, {
            method: 'POST',
            headers: this.options.headers, // Include custom headers
            body: formData
        })
        .then(response => response.text())
        .then(html => {
           
        })
        .catch((error) => {
            console.error('Error:', error);
            this.openNotificationsToast("Error occurred while deleting message");
        });
    }

    textReplaceURLs(text) {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>';
        });
    }

    chatColorStringMention(str) {
        return str.replace(/@(\w+)/g, '<span class="teyuto-chat-mention">@$1</span>');
    }

    openNotificationsToast(message) {
        const toast = document.createElement('div');
        toast.className = 'teyuto-chat-toast';
        toast.textContent = message;
        document.body.appendChild(toast);

        // Style for the toast
        toast.style.position = 'fixed';
        toast.style.bottom = '20px';
        toast.style.right = '20px';
        toast.style.backgroundColor = this.options.darkMode ? '#2a2a2a' : '#f1f1f1';
        toast.style.color = this.options.darkMode ? '#ffffff' : '#000000';
        toast.style.padding = '10px 20px';
        toast.style.borderRadius = '5px';
        toast.style.opacity = '0';
        toast.style.transition = 'opacity 0.5s ease-in-out';

        // Show the toast
        setTimeout(() => {
            toast.style.opacity = '1';
        }, 100);

        // Hide the toast after 3 seconds
        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
                document.body.removeChild(toast);
            }, 500);
        }, 3000);

        console.log(`Notification: ${message}`);
    }

    setDarkMode(isDark) {
        this.options.darkMode = isDark;
        this.applyStyles();
    }
}
